import DeletedUsersList from "./DeletedUserList";
export default {
    list: DeletedUsersList,
};
